export var DATE_SEPARATOR = '-';
export var TIME_SEPARATOR = ':';
export var DATE_FORMAT = "yyyy".concat(DATE_SEPARATOR, "MM").concat(DATE_SEPARATOR, "dd");
export var TIME_FORMAT = "HH".concat(TIME_SEPARATOR, "mm");